import { Injectable } from '@angular/core';
import { BaseService } from './base/base.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { ErrorHandlerService } from './error-handler.service';
import { Observable } from 'rxjs';
import { StyleContentHeader } from 'src/app/shared/models/styleContent';

@Injectable({
  providedIn: 'root'
})
export class HeaderService extends BaseService {

  private env = environment;

  constructor(
    http: HttpClient,
    errorHandlerService: ErrorHandlerService) {
    super(http, errorHandlerService);
  }

  getHeader(): Observable<StyleContentHeader> {
    return this.get<StyleContentHeader>(`${this.env.publicApiSocioUrl}v1/socio/header-config`);
  }
}
